module.exports = __webpack_public_path__ + "img/logo_completo.be41de52.png";